/* eslint-disable import/prefer-default-export,no-new,no-console,prefer-const,no-unused-vars */
import apiPromocode from '@/api/promocode'
import * as types from './mutation_types'

export default {
  setPromocode: async ({ commit }, promocode) => {
    commit(types.SET_PROMOCODE, promocode)
  },
  postOrdersPromocodeApply: async ({ rootState, commit, getters, rootGetters }, {
    orderId,
    promocode,
  }) => {
    if (!promocode) {
      return
    }

    try {
      const response = await apiPromocode.postOrdersPromocodeApply({
        orderId_H: orderId,
        promocode,
      })
      return response.body
    } catch (error) {
      return error
    }
  },
}
